
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import ProgressBar from '@/components/musicians/match/ProgressBar';
import { TwitchIcon, Instagram, Youtube } from 'lucide-react';

const ContentPerformance: React.FC = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Content Performance</CardTitle>
        <CardDescription>How your recent content performed</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          <div>
            <div className="flex items-center justify-between mb-1">
              <span className="text-sm font-medium flex items-center gap-1.5">
                <TwitchIcon className="h-3.5 w-3.5" />
                "Day in the Studio" TikTok
              </span>
              <span className="text-sm font-medium text-green-500">+412%</span>
            </div>
            <ProgressBar 
              label="Views vs. Average" 
              value={92} 
              color="bg-green-500"
            />
          </div>
          
          <div>
            <div className="flex items-center justify-between mb-1">
              <span className="text-sm font-medium flex items-center gap-1.5">
                <Instagram className="h-3.5 w-3.5" />
                "New Track Teaser" Reel
              </span>
              <span className="text-sm font-medium text-green-500">+218%</span>
            </div>
            <ProgressBar 
              label="Views vs. Average" 
              value={78} 
              color="bg-green-500"
            />
          </div>
          
          <div>
            <div className="flex items-center justify-between mb-1">
              <span className="text-sm font-medium flex items-center gap-1.5">
                <Youtube className="h-3.5 w-3.5" />
                "Making the Beat" Tutorial
              </span>
              <span className="text-sm font-medium text-amber-500">+24%</span>
            </div>
            <ProgressBar 
              label="Views vs. Average" 
              value={45} 
              color="bg-amber-500"
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ContentPerformance;
